import * as React from "react";
// 消息枚举
import { ENoticeType } from "utils/enum/notice";

interface ITabbarProps {
  // 未读数据总数
  unReadtotal?: any;
  // 收藏数据总数
  collectTotal?: any;
  // 设置选中项
  setTabIndex?: any;
}

class Tabbar extends React.PureComponent<ITabbarProps, any> {
  state = {
    key: ENoticeType.All
  };
  constructor(props: ITabbarProps) {
    super(props);
  }

  onClick = (e, key) => {
    this.setState({
      key
    });

    this.props.setTabIndex(key);
  };

  // 设置tab项的样式
  setClassName = key => {
    let act = "tabbar-activity";
    if (key != this.state.key) {
      act = "";
    }
    switch (key) {
      case ENoticeType.All:
        return "tabbar-item " + act;
      case ENoticeType.Unread:
        return "tabbar-item tabbar-item__unread " + act;
      case ENoticeType.Collect:
        return "tabbar-item tabbar-item__collect " + act;
      default:
        return "tabbar-item " + act;
    }
  };

  // 显示数据总数
  showCount = total => {
    total = total || 0;
    return total > 0 ? `(${total})` : null;
  };

  render() {
    const getOnclick = key => {
      return e => {
        this.onClick(e, key);
      };
    };
    return (
      <div className="tabbar">
        <div
          className={this.setClassName(ENoticeType.All)}
          onClick={getOnclick(ENoticeType.All)}
        >
          全部
        </div>
        <div
          className={this.setClassName(ENoticeType.Unread)}
          onClick={getOnclick(ENoticeType.Unread)}
        >
          <i className="action-user action-gantanhao" />
          未读
          {this.showCount(this.props.unReadtotal)}
        </div>
        <div
          className={this.setClassName(ENoticeType.Collect)}
          onClick={getOnclick(ENoticeType.Collect)}
        >
          <i className="action-user action-star" />
          收藏
          {this.showCount(this.props.collectTotal)}
        </div>
      </div>
    );
  }
}

export default Tabbar;
